// extracted by css-extract-rspack-plugin
export default {"collapse":"collapse-KZp_dN","isOpen":"isOpen-sTFLur","inner":"inner-fXNa1D"};